
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/effective-classes",
      function () {
        return require("private-next-pages/school/effective-classes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/effective-classes"])
      });
    }
  